/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { adminv3_ChatbotTestConfigurationResponse } from "../models/adminv3_ChatbotTestConfigurationResponse"
import type { adminv3_CreateChatbotTestConfigurationRequest } from "../models/adminv3_CreateChatbotTestConfigurationRequest"
import type { adminv3_UpdateChatbotTestConfigurationRequest } from "../models/adminv3_UpdateChatbotTestConfigurationRequest"
import type { avy_api_internal_avyframework_avyhttp_ListRequest } from "../models/avy_api_internal_avyframework_avyhttp_ListRequest"
import type { avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestConfigurationResponse } from "../models/avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestConfigurationResponse"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class ChatbotTestConfigurationService {
    /**
     * Create a new chatbot test configuration
     * Create a new chatbot test configuration with the provided details
     * @returns adminv3_ChatbotTestConfigurationResponse Created
     * @throws ApiError
     */
    public static postV3AdminChatbotTestConfiguration({
        request,
    }: {
        /** Create Chatbot Test Configuration Request **/
        request: adminv3_CreateChatbotTestConfigurationRequest
    }): CancelablePromise<adminv3_ChatbotTestConfigurationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/chatbot-test-configuration",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * List chatbot test configurations
     * List chatbot test configurations with pagination and filtering
     * @returns avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestConfigurationResponse OK
     * @throws ApiError
     */
    public static postV3AdminChatbotTestConfigurationList({
        request,
    }: {
        /** Chatbot test configuration list request **/
        request: avy_api_internal_avyframework_avyhttp_ListRequest
    }): CancelablePromise<avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_ChatbotTestConfigurationResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/chatbot-test-configuration/list",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Get chatbot test configuration
     * Get a single chatbot test configuration by ID
     * @returns adminv3_ChatbotTestConfigurationResponse OK
     * @throws ApiError
     */
    public static getV3AdminChatbotTestConfiguration({
        id,
    }: {
        /** Chatbot Test Configuration ID **/
        id: number
    }): CancelablePromise<adminv3_ChatbotTestConfigurationResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v3/admin/chatbot-test-configuration/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Update chatbot test configuration
     * Update a single chatbot test configuration by ID
     * @returns adminv3_ChatbotTestConfigurationResponse OK
     * @throws ApiError
     */
    public static putV3AdminChatbotTestConfiguration({
        id,
        request,
    }: {
        /** Chatbot Test Configuration ID **/
        id: number
        /** Update Chatbot Test Configuration Request **/
        request: adminv3_UpdateChatbotTestConfigurationRequest
    }): CancelablePromise<adminv3_ChatbotTestConfigurationResponse> {
        return __request(OpenAPI, {
            method: "PUT",
            url: "/v3/admin/chatbot-test-configuration/{id}",
            path: {
                id: id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Delete chatbot test configuration
     * Delete a single chatbot test configuration by ID
     * @returns any OK
     * @throws ApiError
     */
    public static deleteV3AdminChatbotTestConfiguration({
        id,
    }: {
        /** Chatbot Test Configuration ID **/
        id: number
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: "DELETE",
            url: "/v3/admin/chatbot-test-configuration/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }
}
